<nav aria-label="breadcrumb">
    <a [routerLink]="['/documents']">Accueil</a> <mat-icon>arrow_right</mat-icon>{{ element }}
</nav>

<mat-card>
    <mat-card-content>
        <mat-tab-group mat-stretch-tabs="false" (selectedTabChange)="changeTab($event)" [color]="element === 'Partages' ? 'accent' : 'primary'">
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="icons">group</mat-icon>
                <span [ngClass]="element === 'Partages' ? 'color_red' : 'color_disabled'" style="font-size: 14px; line-height: 16px; font-weight: bold;">Partages</span>
              </ng-template>
              <div class="filter-head" fxLayout="row" fxLayoutAlign="end">
                  <div class="filter" fxLayout="row">
                      <mat-label>Rechercher : </mat-label>

                      <mat-form-field class="field">
                          <input class="form-input" matInput (keyup)="applyFilterShared($event)" maxlength="100">
                      </mat-form-field>

                      <mat-form-field class="field-date" [formGroup]="range" appearance="fill">
                          <mat-date-range-input [rangePicker]="picker">
                            <input
                              matStartDate
                              formControlName="startDate"
                              placeholder="Date de début"
                              [max]="max"
                              [min]="min"
                              #dateRangeStart
                              (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)"
                              (beforeinput)="onInput($event)"
                            />
                            <input
                              matEndDate
                              formControlName="endDate"
                              placeholder="Date de fin"
                              [max]="max"
                              [min]="min"
                              #dateRangeEnd
                              (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)"
                              (beforeinput)="onInput($event)"
                            />
                          </mat-date-range-input>
                        
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field>
                  </div>
                  <div class="button-export" fxLayoutAlign="end">
                      <button mat-raised-button color="primary" class="primary-button" 
                          (click)="exportToCsv(true)" aria-label="Export CSV">Export CSV</button>
                  </div>
              </div>

              <mat-table [dataSource]="dataSourceShared" matSort [matSortActive]="'sendAt'" 
                  (matSortChange)="sortData($event, dataSourceShared, partages)" matSortDirection="desc">
                  <!-- Nom du prospect -->
                  <ng-container matColumnDef="nameProspect">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div mat-sort-header>Nom du prospect</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{element?.firstNameProspect}} {{element?.lastNameProspect}}</mat-cell>
                  </ng-container>
              
                  <!-- Email du prospect -->
                  <ng-container matColumnDef="emailProspect">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div mat-sort-header>Email du prospect</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{element?.emailProspect}}</mat-cell>
                  </ng-container>
              
                  <!-- Raison social -->
                  <ng-container matColumnDef="socialReason">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div mat-sort-header>Dénomination sociale</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{element?.socialReason}}</mat-cell>
                  </ng-container>

                  <!-- Nom souscripteur -->
                  <ng-container matColumnDef="nameSender">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div mat-sort-header>Nom souscripteur Helvetia</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{element?.firstNameSender}} {{element?.lastNameSender}}</mat-cell>
                  </ng-container>
              
                  <!-- Date d'envoi -->
                  <ng-container matColumnDef="sentAt">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div class="content">
                            <div mat-sort-header>Date d'envoi</div>
                        </div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{ element.sentAt | date: 'dd/MM/YYYY HH:mm' }}</mat-cell>
                  </ng-container>
              
                  <!-- Marché -->
                  <ng-container matColumnDef="marketName">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div mat-sort-header>Marché</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{element?.marketName}}</mat-cell>
                  </ng-container>
              
                  <!-- Support -->
                  <ng-container matColumnDef="supportName">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div mat-sort-header>Support</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{element?.supportName}}</mat-cell>
                  </ng-container>
              
                  <!-- Document -->
                  <ng-container matColumnDef="documentName">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div mat-sort-header>Document</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element" [matTooltip]="element?.documentName">{{element?.documentName}}</mat-cell>
                  </ng-container>
              
                  <mat-header-row *matHeaderRowDef="displayedColumnsShared" color="primary"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumnsShared;"></mat-row>
              </mat-table>

              <mat-paginator
                  #paginator="matPaginator"
                  [pageSize]="10" 
                  [pageSizeOptions]="[5, 10, 20]" 
                  [showFirstLastButtons]="true"
                  >
              </mat-paginator>
            </mat-tab>

            <mat-tab [ngClass]="element === 'Statistiques' ? '' : 'inactive'">
              <ng-template mat-tab-label>
                <mat-icon class="icons_bis">insert_chart</mat-icon>
                <span [ngClass]="element === 'Statistiques' ? 'color_purple' : ''" style="font-size: 14px; line-height: 16px; font-weight: bold;">Statistiques</span>
              </ng-template>
              <div class="filter-head" fxLayout="row" fxLayoutAlign="end">
                  <div class="filter" fxLayout="row">
                      <mat-label>Rechercher : </mat-label>

                      <mat-form-field class="field">
                          <input class="form-input" matInput (keyup)="applyFilterStatistics($event)" maxlength="100">
                      </mat-form-field>

                      <mat-form-field class="field-date" [formGroup]="range" appearance="fill">
                          <mat-date-range-input [rangePicker]="pickerStatistics">
                            <input
                              matStartDate
                              formControlName="startDate"
                              placeholder="Date de début"
                              [max]="max"
                              [min]="min"
                              #dateRangeStart
                              (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)"
                              (beforeinput)="onInput($event)"
                            />
                            <input
                              matEndDate
                              formControlName="endDate"
                              placeholder="Date de fin"
                              [max]="max"
                              [min]="min"
                              #dateRangeEnd
                              (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)"
                              (beforeinput)="onInput($event)"
                            />
                          </mat-date-range-input>
                        
                          <mat-datepicker-toggle matIconSuffix [for]="pickerStatistics"></mat-datepicker-toggle>
                          <mat-date-range-picker #pickerStatistics></mat-date-range-picker>
                      </mat-form-field>
                  </div>
                  <div class="button-export" fxLayoutAlign="end">
                      <button mat-raised-button color="primary" class="primary-button" 
                          (click)="exportToCsv(false)" aria-label="Export CSV">Export CSV</button>
                  </div>
              </div>

              <mat-table [dataSource]="dataSourceStatistics" matSort [matSortActive]="'nbDownload'"
                  (matSortChange)="sortData($event, dataSourceStatistics, statistiques)" matSortDirection="desc">
                  <!-- Nombre de partages -->
                  <ng-container matColumnDef="nbDownload">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div mat-sort-header>Nombre de partages</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{element?.nbDownload}}</mat-cell>
                  </ng-container>

                  <!-- Document -->
                  <ng-container matColumnDef="documentName">
                      <mat-header-cell class="header" *matHeaderCellDef>
                          <div mat-sort-header>Document</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element" [matTooltip]="element?.documentName">{{element?.documentName}}</mat-cell>
                  </ng-container>
              
                  <!-- Marché -->
                  <ng-container matColumnDef="marketName">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div mat-sort-header>Marché</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{element?.marketName}}</mat-cell>
                  </ng-container>
              
                  <!-- Support -->
                  <ng-container matColumnDef="supportName">
                      <mat-header-cell class="header" *matHeaderCellDef>
                        <div mat-sort-header>Support</div>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{element?.supportName}}</mat-cell>
                  </ng-container>
              
                  <mat-header-row *matHeaderRowDef="displayedColumnsStatistics" color="primary"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumnsStatistics;"></mat-row>
              </mat-table>

              <mat-paginator
                  #paginatorStatistics="matPaginator"
                  [pageSize]="10" 
                  [pageSizeOptions]="[5, 10, 20]" 
                  [showFirstLastButtons]="true"
                  >
              </mat-paginator>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>